import { useCallback, useState } from "react";

export const useToggleModal = () => {
  const [isOpen, setIsOpen] = useState<boolean>(false);

  const toggleModal = useCallback(() => setIsOpen((x) => !x), []);

  return { isOpen, toggleModal };
};
